/**
 * ES 경로 디버그 로그 스위치.
 *
 * **의존성이 없다 — 어느 쪽에서 불러도 안전하다.** 쿼리 조립 모듈이 서버에서도
 * import 되므로, 이 스위치가 무언가를 끌고 오면 route handler 가 스치기만 해도 그것이
 * 딸려 온다. 여기에는 아무것도 import 하지 않는다.
 */

/** 대량 console로 인한 지연 방지 — 필요 시 `NEXT_PUBLIC_DEBUG_ES=1` */
export function logElsTrace(...args: unknown[]): void {
  if (typeof process !== 'undefined' && process.env.NEXT_PUBLIC_DEBUG_ES === '1') {
    console.log(...args);
  }
}
